/*
 * @Author: ttheitao
 * @Date: 2024-04-01 09:19:59
 * @Description: some description
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-07-30 17:15:42
 */
/* eslint-disable */

export default class Util {
  static generateUUID(len = 10, radix: null | number = null) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [],
      i;
    radix = radix || chars.length;

    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
      // rfc4122, version 4 form
      var r;

      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';

      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join('');
  }

  static formatDate = (value: any) => {
    let date = new Date(value);
    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return year + "-" + month + "-" + day;
  }

  static copyToClipboard = (value: string) => {
    try {
      navigator.clipboard.writeText(value);
      console.log('值已成功复制到剪切板:', value);
    } catch (err) {
      console.error('无法复制值到剪切板:', err);
    }
  }
}